import type { TranslationKey } from './fi';

export const en: Record<TranslationKey, string> = {
  'app.title': 'Calculators',
  'meta.title': 'Calculators',
  'meta.description': 'Handy calculators, also for mobile!',

  'nav.all': 'All',
  'nav.time': 'Timestamps',
  'nav.numbers': 'Numbers & symbols',
  'nav.identifiers': 'Identifiers',
  'nav.colors': 'Colors',
  'nav.bytesizes': 'Byte sizes',
  'nav.links': 'Links',
  'nav.textConversions': 'Text conversions',
  'nav.cryptography': 'Cryptography',
  'nav.pixeldensity': 'Pixel density',
  'nav.worktime': 'Work time',

  'theme.system': 'System theme',
  'theme.light': 'Light theme',
  'theme.dark': 'Dark theme',

  'lang.toggleTooltip': 'Switch to Finnish',

  'page.numbers.title': 'Numbers',
  'page.numbers.binary': 'Binary',
  'page.numbers.octal': 'Octal',
  'page.numbers.decimal': 'Decimal',
  'page.numbers.hex': 'Hex',
  'page.numbers.char': 'Character',
  'page.numbers.unicode': 'Unicode',
  'page.numbers.html': 'HTML entity',

  'page.time.title': 'Timestamps',
  'page.time.label.date': 'Date',
  'page.time.label.time': 'Time',
  'page.time.label.week': 'Week',
  'page.time.label.nameDay': 'Name day',
  'page.time.label.nameDaySearch': 'Find name day',
  'page.time.label.javaTime': 'Java/JS time',
  'page.time.label.unixTime': 'Unix time',
  'page.time.label.iso8601': 'ISO (local)',
  'page.time.label.iso8601utc': 'ISO (UTC)',
  'page.time.weekDay.mon': 'Mon',
  'page.time.weekDay.tue': 'Tue',
  'page.time.weekDay.wed': 'Wed',
  'page.time.weekDay.thu': 'Thu',
  'page.time.weekDay.fri': 'Fri',
  'page.time.weekDay.sat': 'Sat',
  'page.time.weekDay.sun': 'Sun',

  'page.identifiers.title': 'Identifiers',
  'page.identifiers.hetu': 'Finnish HETU',
  'page.identifiers.bankReference': 'Finnish bank ref',
  'page.identifiers.companyId': 'Finnish Y-tunnus',
  'page.identifiers.luhn': 'Luhn modulo 10',
  'page.identifiers.randomString': 'Random string',

  'page.colors.title': 'Color',
  'page.colors.hex.subtitle': 'Hex code',
  'page.colors.rgb.subtitle': 'RGB value',
  'page.colors.hex.label': 'Hex',
  'page.colors.rgb.label': 'RGB value',
  'page.colors.addColor': 'Save color',
  'page.colors.addColorPrompt': 'Enter a name for the color',
  'page.colors.hsl.h': 'H: Hue',
  'page.colors.hsl.s': 'S: Saturation',
  'page.colors.hsl.l': 'L: Lightness',

  'page.bytesizes.title': 'Byte sizes',
  'page.bytesizes.byte': 'Bytes',
  'page.bytesizes.kibi': 'Kibibytes',
  'page.bytesizes.mebi': 'Mebibytes',
  'page.bytesizes.gibi': 'Gibibytes',
  'page.bytesizes.tebi': 'Tebibytes',
  'page.bytesizes.kilo': 'Kilobytes',
  'page.bytesizes.mega': 'Megabytes',
  'page.bytesizes.giga': 'Gigabytes',
  'page.bytesizes.tera': 'Terabytes',

  'page.pixeldensity.title': 'Pixel density',
  'page.pixeldensity.width': 'Width',
  'page.pixeldensity.height': 'Height',
  'page.pixeldensity.widthPlaceholder': 'width',
  'page.pixeldensity.heightPlaceholder': 'height',

  'page.worktime.title': 'Work time',
  'page.worktime.subtitle': 'Daily working hours tracker',
  'page.worktime.start': 'Start',
  'page.worktime.entries': 'Entries',
  'page.worktime.end': 'End',
  'page.worktime.now': 'Now',
  'page.worktime.setNow': 'Set to current time',
  'page.worktime.clockIn': 'Clock in',
  'page.worktime.pause': 'Pause',
  'page.worktime.resume': 'Resume',
  'page.worktime.addRow': 'Add row',
  'page.worktime.removeRow': 'Remove row',
  'page.worktime.clear': 'Clear',
  'page.worktime.subtractLunch': 'Lunch',
  'page.worktime.subtractCommute': 'Commute',
  'page.worktime.minutes': 'min',
  'page.worktime.target': 'Target',
  'page.worktime.hours': 'h',
  'page.worktime.worked': 'Worked',
  'page.worktime.away': 'Away',
  'page.worktime.remaining': 'Remaining',
  'page.worktime.leaveAt': 'Leave at',
  'page.worktime.noRows': 'No entries. Press Clock in when you start working.',
  'page.worktime.error.endBeforeStart': 'End time is before the start time',
  'page.worktime.error.startInFuture': 'Start time is in the future',
  'page.worktime.error.overlap': 'Row overlaps the one before it',

  'page.links.title': 'Links',
  'page.links.subtitle': 'Store your links here',
  'page.links.label': 'Link',

  'page.cryptography.title': 'Cryptography',
  'page.cryptography.input': 'Input',

  'page.pipeline.title': 'Text conversions',
  'page.pipeline.subtitle': 'Data pipeline',
  'page.pipeline.processing': 'Processing…',
  'pipeline.input.label': 'Input',
  'pipeline.input.clear': 'Clear',
  'pipeline.input.placeholder': 'Type or paste text, or drop a file here…',
  'pipeline.input.dropHere': 'Drop file here',
  'pipeline.input.chooseFile': 'Choose file',
  'pipeline.input.fetch': 'Fetch',
  'pipeline.input.fetchFailed': 'Fetch failed (CORS?)',
  'pipeline.input.chars': 'characters',
  'pipeline.input.mode.text': 'Text / file',
  'pipeline.input.mode.randomString': 'Random string',
  'pipeline.input.mode.randomBytes': 'Random bytes',
  'pipeline.input.length': 'Length',
  'pipeline.input.regenerate': 'Regenerate',
  'pipeline.input.randomBytesInfo': 'Random data',
  'pipeline.output.result': 'Result',
  'pipeline.output.download': 'Download',
  'pipeline.output.bytes': 'bytes',
  'pipeline.output.chars': 'characters',
  'pipeline.step.remove': 'Remove',
  'pipeline.addOperation': 'Add operation',
  'pipeline.addPipeline': 'Add pipeline',
  'pipeline.removePipeline': 'Remove pipeline',
  'pipeline.defaultTitle': 'Pipeline',
  'pipeline.renameTitle': 'Rename pipeline',
  'pipeline.reset': 'Reset',
  'pipeline.saveSetup': 'Save setup',
  'pipeline.saveSetupPrompt': 'Enter a name for this setup',
  'pipeline.loadSetup': 'Load setup',
  'pipeline.render.download': 'Download',
  'pipeline.render.unknownImage': 'Unknown image format',
  'pipeline.render.notSvg': 'Data is not in SVG format',

  'component.subtitlePlaceholder': 'Select a value',
  'component.copyToClipboard': 'Copy to clipboard',
  'component.copyHexToClipboard': 'Copy hex string to clipboard',
  'component.lastValuePlaceholder': 'Last value',
  'component.generateNew': 'Generate new',
  'component.nameDaySearchPlaceholder': 'Find a name day',
  'component.checkUuid': 'Check UUID',
  'component.uuidTimestampMs': 'Timestamp (ms)',
  'component.uuidTime': 'Decoded time',
};
